import RecipeDetailMain, { RecipeDetailMainProps } from "./RecipeDetailMain";

export { RecipeDetailMain, RecipeDetailMainProps };

export default RecipeDetailMain;
